/* eslint no-underscore-dangle:0 */

import React, { Component } from "react";
import convert from "xml-js";
import Cookies from "js-cookie";
import BusService from "../../util/busService";
import { isNumber } from "../../util/tools";
import BusStopResults from "./BusStopResults";
import SearchResults from "./SearchResults";
import RecentSearchResults from "./RecentSearchResults";
import Loader from "./Loader";

class NextBus extends Component {
  constructor(props) {
    super(props);

    this.busService = new BusService();
    this.msTimetableFetchInterval = 15 * 1000;
    this.fetchIntervalID = 0;

    const platformListCookie = Cookies.getJSON("metroplatform");

    this.state = {
      loading: false,
      noInput: false,
      searchInput: "",
      currentPlatform: 0,
      viewRecent: false,
      viewBusStopResults: false,
      requestError: false,
      errorMessage: "Oops! Looks like something went wrong.",
      platformList:
        platformListCookie !== undefined && Array.isArray(platformListCookie)
          ? platformListCookie
          : [],
      busStopResults: {},
      searchResults: {}
    };
  }

  componentDidMount() {
    const { platformList } = this.state;
    if (platformList.length) {
      const {
        PlatformTag,
        PlatformNo,
        PlatformName,
        RouteNos
      } = platformList[0];
      this.setPlatform(PlatformTag, PlatformNo, PlatformName, RouteNos);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { platformList } = this.state;

    if (prevState.platformList !== platformList) {
      Cookies.set("metroplatform", platformList, {
        expires: 365
      });
    }
  }

  setPlatform(PlatformTag, PlatformNo, PlatformName, RouteNos) {
    const { platformList } = this.state;

    this.setState({
      loading: true
    });

    const ID = PlatformTag;
    // Always add latest platform to the top of the list
    const newPlatformList = platformList.filter(e => e.ID !== ID);
    this.setState({
      currentPlatform: PlatformTag,
      platformList: [
        {
          ID,
          PlatformTag,
          PlatformNo,
          PlatformName,
          RouteNos
        },
        ...newPlatformList
      ]
    });

    // Set platform Results
    this.fetchBusTimetable(PlatformTag);
    this.setIntervalFetch();
  }

  setIntervalFetch() {
    this.fetchIntervalID = setInterval(
      () => this.refetchBusTimetable(),
      this.msTimetableFetchInterval
    );
  }

  refetchBusTimetable() {
    const { currentPlatform, viewBusStopResults } = this.state;

    if (currentPlatform && viewBusStopResults) {
      this.fetchBusTimetable(currentPlatform);
    } else {
      clearInterval(this.fetchIntervalID);
    }
  }

  fetchBusTimetable(currentPlatform) {
    BusService.submitRTISearchWithPlatformTag(currentPlatform)
      .then(result => {
        const bsResult = convert.xml2js(result.data, {
          compact: true
        });

        if (!bsResult.JPRoutePositionET.Platform.Route) {
          throw new Error("There's currently no scheduled times for this stop");
        }

        this.setState({
          busStopResults: bsResult.JPRoutePositionET.Platform,
          loading: false,
          viewBusStopResults: true,
          viewRecent: false,
          requestError: false
        });
      })
      .catch(error => {
        // Clear our cookie so we're not saving
        // a broken platform to the state
        Cookies.remove("metroplatform");

        const errorMessage = error.message ? error.message : "";

        this.setState({
          requestError: true,
          loading: false,
          viewBusStopResults: true,
          errorMessage
        });
      });
  }

  resetPlatformList() {
    this.setState({
      platformList: []
    });
  }

  updateSearchInput(e) {
    this.setState({
      searchInput: e.target.value
    });
  }

  viewRecentSearches() {
    this.setState({
      viewRecent: true,
      noInput: false,
      viewBusStopResults: false,
      loading: false,
      requestError: false
    });
  }

  findBus() {
    const { searchInput, viewRecent } = this.state;

    if (searchInput === "") {
      if (viewRecent === true) {
        return false;
      }

      this.setState({
        noInput: true
      });

      return false;
    }

    this.setState({
      loading: true,
      requestError: false,
      noInput: false
    });

    if (isNumber(searchInput)) {
      BusService.platformResults(searchInput).then(platformData => {
        if (platformData.data.features.length) {
          const {
            PlatformTag,
            PlatformNo,
            PlatformName,
            RouteNos
          } = platformData.data.features[0].attributes;

          this.setPlatform(PlatformTag, PlatformNo, PlatformName, RouteNos);
        } else {
          this.setState({
            busStopResults: {},
            loading: false,
            viewRecent: false,
            viewBusStopResults: false,
            requestError: true,
            errorMessage:
              "No stops match this number. Please try searching with a different number, or with a street name."
          });
        }
      });
    } else {
      BusService.platformsByStreet(searchInput).then(result => {
        this.setState({
          loading: false,
          searchResults: result,
          viewRecent: false,
          viewBusStopResults: false
        });
      });
    }

    return true;
  }

  render() {
    const {
      loading,
      noInput,
      requestError,
      searchInput,
      busStopResults,
      searchResults,
      platformList,
      viewRecent,
      viewBusStopResults,
      errorMessage
    } = this.state;

    const busStopResultsVisible =
      !loading && !noInput && !requestError && viewBusStopResults;
    const searchResultsVisible =
      !loading &&
      !noInput &&
      !requestError &&
      !viewBusStopResults &&
      !viewRecent;
    const recentSearchResultsVisible =
      !loading &&
      !noInput &&
      !requestError &&
      !viewBusStopResults &&
      viewRecent;

    return (
      <div className="next-bus home-page-item bg--purple text--white">
        <div className="flex justify-between">
          <h2 className="home-page-item__title">
            Next bus
            <br />
            <span className="home-page-item__title--small">
              due at your stop
            </span>
          </h2>
          <div className="next-bus__note">Updates every 10 secs</div>
        </div>
        <div className="next-bus__input">
          <input
            className="next-bus__text-input"
            type="text"
            value={searchInput}
            onChange={e => this.updateSearchInput(e)}
            placeholder="Enter street or stop no"
            onKeyPress={e => {
              if (e.which === 13) {
                this.findBus();
              }
            }}
          />
          <button
            className="btn btn--white"
            type="button"
            onClick={() => this.findBus()}
          >
            Check
          </button>
        </div>
        <Loader loading={loading} />
        {noInput && (
          <div>Please enter a road or street name on which to find a stop</div>
        )}

        {requestError && !loading && <div>{errorMessage}</div>}

        {busStopResultsVisible && (
          <BusStopResults
            Results={busStopResults}
            PlatformNo={platformList[0].PlatformNo}
          />
        )}

        {searchResultsVisible && searchResults.features && (
          <SearchResults
            SearchQuery={searchInput}
            Title="Click on a stop name to see buses due at that stop:"
            Results={searchResults.features}
            handlePlatformSelect={(
              platformTag,
              platformNo,
              platformName,
              routeNos
            ) =>
              this.setPlatform(platformTag, platformNo, platformName, routeNos)
            }
          />
        )}
        {recentSearchResultsVisible && (
          <RecentSearchResults
            Title="Click on a stop name to see buses due at that stop:"
            Results={platformList}
            handleSearchDelete={() => this.resetPlatformList()}
            handlePlatformSelect={(platformTag, platformNo, platformName) =>
              this.setPlatform(platformTag, platformNo, platformName)
            }
          />
        )}
        <div className="flex justify-end">
          <button
            className="btn-link btn-link--white"
            type="button"
            onClick={() => this.viewRecentSearches()}
          >
            Recent Searches
          </button>
        </div>
      </div>
    );
  }
}

export default NextBus;
